var map = {
	"./1514407740.svg": 2861,
	"./178.svg": 1974,
	"./2.svg": 7470,
	"./208.svg": 4254,
	"./272.svg": 4404,
	"./399.svg": 4732,
	"./478.svg": 6816,
	"./90.svg": 8549,
	"./_1856953595.svg": 2448,
	"./_411938112.svg": 5634,
	"./sample-goal-icon.svg": 9695
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1017;